import { Resource } from "../resource/resource.model";

/**
 * 4Bridge Notification Setting Model
 * Represents notification configuration for a tenant
 */
export class BridgeNotificationSetting extends Resource {
    emailEnabled: boolean;
    emailRecipients: string[];
    webhookEnabled: boolean;
    webhookEndpointIds: string[];
    notifyOnSyncSuccess: boolean;
    notifyOnSyncFailure: boolean;
    notifyOnConnectionError: boolean;
    dailyDigestEnabled: boolean;
    dailyDigestTime?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

/**
 * Request DTO for creating/updating notification settings
 */
export interface UpsertNotificationSettingRequest {
    emailEnabled?: boolean;
    emailRecipients?: string[];
    webhookEnabled?: boolean;
    webhookEndpointIds?: string[];
    notifyOnSyncSuccess?: boolean;
    notifyOnSyncFailure?: boolean;
    notifyOnConnectionError?: boolean;
    dailyDigestEnabled?: boolean;
    dailyDigestTime?: string;
}

/**
 * Notification type enum
 */
export enum NotificationType {
    EMAIL = 'email',
    WEBHOOK = 'webhook',
    IN_APP = 'in_app'
}

/**
 * Notification event enum
 */
export enum NotificationEvent {
    SYNC_SUCCESS = 'sync_success',
    SYNC_FAILURE = 'sync_failure',
    CONNECTION_ERROR = 'connection_error',
    DAILY_DIGEST = 'daily_digest'
}
